import {
    bookingComplete,
    focusLiftPass,
    focusSkiSchool,
    removeExtraFromRow, resetDefaultRows,
    startSubmitExtras,
    stopSubmitExtras,
    updateSelectedExtraData
} from './core';
import {focusEquipmentHire, updatePersonDetails, setSkiInformationVisibility, addRow, removeRow} from './core';
import {Map, List, fromJS, isImmutable} from 'immutable';
import moment from 'moment/moment';

/*export const INITIAL_STATE = Map({
    leadBooker: Map({
        name: 'John Smith',
        dateOfBirth: moment('04/02/1992', 'DD/MM/YYYY')
    }),
    bookingStartDate: moment('12/12/2018', 'DD/MM/YYYY'),
    bookingEndDate: moment('19/12/2018', 'DD/MM/YYYY'),
    visibleEquipmentHireModal: null,
    visibleLiftPassModal: null,
    visibleSkiSchoolModal: null,
    availableExtras: Map({
        equipmentHire: Map({
            name: 'Equipment hire',
            helmetPrices: Map({adult: 21, child: 18}),
            types: List([
                Map({
                    name: 'B-superior Carver',
                    durationPrices: Map({
                        6: 50,
                        7: 55
                    }),
                    imageUrl: 'https://source.unsplash.com/1600x900/?skiing,snowboarding',
                    description: 'Carving skis are the ideal ski for those that like skiing mostly groomers or hard pack. They do not perform well in powder and usually have too much shape for mogul skiing.'
                }),
                Map({
                    name: 'A-inferior non-carver',
                    durationPrices: Map({
                        6: 10,
                        7: 35
                    }),
                    imageUrl: 'https://source.unsplash.com/1600x900/?skis,snowboard',
                    description: 'Frontside Skis have narrower waists that are designed to make skidded or carved turns on the trails and groomers only.'
                })
            ])
        }),
        liftPasses: Map({
            name: 'Lift passes',
            types: List([
                Map({
                    name: 'Local area only',
                    durationPrices: Map({
                        6: 120,
                        7: 150
                    }),
                    description: 'This pass covers only the local slopes reachable by the gondola and chairlift.'
                }),
                Map({
                    name: 'Val Thorens and surrounding areas',
                    durationPrices: Map({
                        6: 150,
                        7: 170
                    }),
                    description: 'This pass covers Val Thorens and the surrounding mountains reachable by bus or helicopter'
                }),
                Map({
                    name: 'Whole of France',
                    durationPrices: Map({
                        6: 9150,
                        7: 2170
                    }),
                    description: 'This pass covers every mountain in France.'
                })
            ])
        }),
        skiSchool: Map({
            name: 'Ski school',
            types: List([
                Map({
                    name: '5 day adult school - morning sessions',
                    durationPrices: Map({
                        0: 50
                    }),
                    description: 'This ski school is for adults who can ski on normal slopes. Not for beginners.'
                }),
                Map({
                    name: '6 day adult and child school - morning sessions',
                    durationPrices: Map({
                        0: 60
                    }),
                    description: 'This ski school is for adults with children who can ski on normal slopes. Not for beginners.'
                }),
                Map({
                    name: '5 day beginner child school - morning sessions',
                    durationPrices: Map({
                        0: 70
                    }),
                    description: 'This ski school is for children who have never skiied before.'
                }),
                Map({
                    name: '5 day beginner child school - morning sessions AND afternoon sessions',
                    durationPrices: Map({
                        0: 75
                    }),
                    description: 'This ski school is for children who have never skiied before.'
                }),
            ])
        })
    }),
    emptyRow: Map({
        title: '',
        givenName: '',
        surname: '',
        dateOfBirth: null,
        equipmentHire: Map({
            type: null,
            shoeSize: null,
            height: null,
            sex: null,
            duration: null,
            dateFrom: null,
            helmet: false
        }),
        liftPasses: Map({}),
        skiSchool: Map({})

    }),
    rows: List([
        Map({
            title: 'Mr.',
            givenName: 'John',
            surname: 'Smith',
            dateOfBirth: moment('04/02/1992', 'DD/MM/YYYY'),
            equipmentHire: Map({
                type: null,
                shoeSize: null,
                height: null,
                sex: null,
                duration: null,
                dateFrom: null,
                helmet: false
            }),
            //liftPasses: Map({type: 1, duration: '6'})

        })
    ])
});*/

const INITIAL_STATE_JS = document.getElementById('client-area-ski-extras-data') ? JSON.parse(document.getElementById('client-area-ski-extras-data').getAttribute('data-initialstate')) : Map({});
/*
INITIAL_STATE_JS.bookingStartDate = moment(INITIAL_STATE_JS.bookingStartDate);
INITIAL_STATE_JS.bookingEndDate = moment(INITIAL_STATE_JS.bookingEndDate);
INITIAL_STATE_JS.leadBooker.dateOfBirth = moment(INITIAL_STATE_JS.leadBooker.dateOfBirth);*/
let INITIAL_STATE = Map({});
if (INITIAL_STATE_JS !== null && document.getElementById('client-area-ski-extras-data')) {
//below are the helmetPrices - helmet price different for adult and child but is set across the board


  INITIAL_STATE = fromJS(INITIAL_STATE_JS);
  //console.log(isImmutable(INITIAL_STATE), 'is imm');

  //console.log(INITIAL_STATE, Map.isMap(INITIAL_STATE));
  INITIAL_STATE = INITIAL_STATE.setIn(['availableExtras', 'equipmentHire', 'helmetPrices'], Map({
    adult: 21,
    child: 18
  })).setIn(['bookingRef'], document.getElementById('client-area-ski-extras-data').getAttribute('data-bookingref') || 0)
    .setIn(['submissionInProgress'], false)
    .setIn(['bookingComplete'], false);

  
  INITIAL_STATE = INITIAL_STATE.set('defaultRows', INITIAL_STATE.get('rows', List([])));
}

//console.log(JSON.stringify(INITIAL_STATE.toJS()));

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'FOCUS_EQUIPMENT_HIRE' :
      return focusEquipmentHire(state, action.payload.rowId);
    case 'FOCUS_LIFT_PASS' :
      return focusLiftPass(state, action.payload.rowId);
    case 'FOCUS_SKI_SCHOOL' :
      return focusSkiSchool(state, action.payload.rowId);
    case 'UPDATE_SELECTED_EXTRA_DATA' :
      return updateSelectedExtraData(state, action.payload.rowId, action.payload.extraKey, action.payload.key, action.payload.value);
    /*case 'UPDATE_SELECTED_LIFT_PASS_DATA' :
        return updateSelectedLiftPassData(state, action.payload.rowId, action.payload.key, action.payload.value);*/
    case 'UPDATE_PERSON_DETAILS' :
      return updatePersonDetails(state, action.payload.rowId, action.payload.key, action.payload.value);
    case 'SET_SKI_INFORMATION_VISIBILITY' :
      return setSkiInformationVisibility(state, action.payload.visible);
    case 'ADD_ROW':
      return addRow(state);
    case 'REMOVE_ROW':
      return removeRow(state, action.payload.rowId);
    case 'REMOVE_EXTRA_FROM_ROW':
      return removeExtraFromRow(state, action.payload.rowId, action.payload.extraType);
    case 'START_SUBMIT_EXTRAS':
      return startSubmitExtras(state);
    case 'STOP_SUBMIT_EXTRAS':
      return stopSubmitExtras(state);
    case 'BOOKING_COMPLETE':
      return bookingComplete(state, action.payload.override);
      case 'RESET_DEFAULT_ROWS':
          return resetDefaultRows(state);
  }
  return state;
}
